import { FC } from 'react'
import cn from './index.module.css'
import { SortingTab } from './useHorizontalSorting'
import classNames from 'classnames'
import { DownOutlined } from '@ant-design/icons'

interface IHorizontalSorting {
  label?: string
  tabs: SortingTab[]
  onClick: (tab: SortingTab) => void
}

const HorizontalSorting: FC<IHorizontalSorting> = ({
  label,
  tabs,
  onClick,
}) => {
  return (
    <div className={cn.wrapper}>
      {label && <div className={cn.label}>{label}</div>}
      {tabs?.map((tab) => {
        return (
          <HorizontalTab key={tab.id} tab={tab} onClick={() => onClick(tab)} />
        )
      })}
    </div>
  )
}

const HorizontalTab = ({
  tab,
  onClick,
}: {
  tab: SortingTab
  onClick: () => void
}) => {
  return (
    <div className={cn.tabWrapper} onClick={onClick}>
      <div
        className={classNames(cn.tabLabel, tab.isActive && cn.tabActiveLabel)}
      >
        {tab.label}
      </div>
      {tab?.isActive && tab.order && tab.order !== 'none' && (
        <DownOutlined
          className={classNames(
            cn.orderIcon,
            tab.order === 'desc' ? cn.orderActiveDown : cn.orderActiveUp,
          )}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      )}
    </div>
  )
}

export default HorizontalSorting
